export function createAlertsService(helium) {
	const alertsChannel = helium.factory('ui:alerts', []);
	
	const addAlert = (type, message, duration = 5000) => {
		const id = Date.now().toString(36) + Math.random().toString(36).substr(2);
		const alert = { id, type, message, duration };
		
		alertsChannel.send(alerts => [...alerts, alert]);
		
		if (duration > 0) {
			setTimeout(() => {
				removeAlert(id);
			}, duration);
		}
		
		return id;
	};
	
	const removeAlert = (id) => {
		alertsChannel.send(alerts => alerts.filter(a => a.id !== id));
	};
	
	const clearAlerts = () => {
		alertsChannel.send(() => []);
	};
	
	const success = (message, duration) => addAlert('success', message, duration);
	const error = (message, duration) => addAlert('error', message, duration);
	const warning = (message, duration) => addAlert('warning', message, duration);
	const info = (message, duration) => addAlert('info', message, duration);
	
	return { alertsChannel, addAlert, removeAlert, clearAlerts, success, error, warning, info };
}
